export default "__VITE_ASSET__06127020__"